export default __webpack_public_path__ + "static/media/DediatedApp.a59bcfab.png";